export default "__VITE_ASSET__BjPrD4Kd__"